import { Play, Pause, Rewind, FastForward, Moon } from "lucide-react";
import { usePlayer } from "../../context/PlayerContext";
import { Slider } from "../ui/slider";

function fmt(s) {
  if (!s || Number.isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, "0")}`;
}

export function PlayerBar() {
  const { current, playing, progress, duration, rate, sleepMinutes, toggle, seek, setPlaybackRate, setSleepTimer } = usePlayer();
  if (!current) return null;

  return (
    <div data-testid="persistent-player-bar" className="fixed bottom-0 inset-x-0 z-40 bg-surface/95 backdrop-blur-xl border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-4 py-2 flex items-center gap-4">
        <img src={current.image} alt="" className="w-10 h-10 object-cover hidden sm:block" />
        <div className="min-w-0 w-32 sm:w-48">
          <p className="text-xs truncate text-white">{current.title}</p>
          <p className="text-[10px] text-white/70 truncate">{current.subtitle}</p>
        </div>
        <button data-testid="player-rewind-button" onClick={() => seek(Math.max(0, progress - 15))} className="text-white/70 hover:text-white">
          <Rewind className="w-4 h-4" />
        </button>
        <button data-testid="player-toggle-button" onClick={toggle} className="w-9 h-9 flex items-center justify-center bg-white text-black">
          {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4 ml-0.5" />}
        </button>
        <button data-testid="player-forward-button" onClick={() => seek(progress + 15)} className="text-white/70 hover:text-white">
          <FastForward className="w-4 h-4" />
        </button>
        <span className="text-[10px] text-white/70 hidden sm:block w-10">{fmt(progress)}</span>
        <div className="flex-1 hidden sm:block">
          <Slider
            data-testid="player-seek-slider"
            value={[progress]}
            max={duration || 100}
            step={1}
            onValueChange={([v]) => seek(v)}
          />
        </div>
        <span className="text-[10px] text-white/70 hidden sm:block w-10">{fmt(duration)}</span>
        <select
          data-testid="player-speed-select"
          value={rate}
          onChange={(e) => setPlaybackRate(Number(e.target.value))}
          className="hidden md:block bg-transparent text-xs text-white/70 border border-white/15 px-1 py-1"
        >
          {[0.75, 1, 1.25, 1.5, 2].map((r) => <option key={r} value={r} className="bg-black">{r}x</option>)}
        </select>
        <button
          data-testid="player-sleep-timer-button"
          onClick={() => setSleepTimer(sleepMinutes ? null : 15)}
          title="Sleep timer"
          className={`hidden md:flex items-center gap-1 text-xs ${sleepMinutes ? "text-brandAccent" : "text-white/75"}`}
        >
          <Moon className="w-4 h-4" /> {sleepMinutes ? `${sleepMinutes}m` : ""}
        </button>
      </div>
    </div>
  );
}
